<div class="main">
  <div class="dashboardMain">
    <div class="header">
      <div class="headerLabel">
        {{'LOAD_DASHBOARD.cement' | translate}}
      </div>
      <div class="refreshIcon" (click)="getOrders()">
        <img src="assets/refresh_new.svg" alt="">
      </div>
    </div>
    <div class="ordersection">
      <div class="load_table desktop-view">
        <div class="load">
          <div class="">
            <table mat-table [dataSource]="dataSource" class="loadTable">

              <ng-container matColumnDef="#">
                <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 60px;">
                  #.
                </th>
                <td mat-cell *matCellDef="let element; let i = index;" style="width: 60px;">
                  {{i+1}}.
                </td>
              </ng-container>

              <ng-container matColumnDef="load">
                <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 200px;">
                  {{'LOAD_DASHBOARD.load' | translate}} <br>
                  {{'LOAD_DASHBOARD.SONo' | translate}}
                </th>
                <td mat-cell *matCellDef="let element; let i = index;" style="width: 200px;">
                  {{element.load}}
                  <br>
                  <span style="font-weight: 600;">
                    {{element.SONo}}
                  </span>
                  <div class="indicator">
                    <span *ngIf="element.isParent || element.isChildren"
                      [ngClass]="{'parent-indicator': element.isParent, 'children-indicator': element.isChildren}">
                      {{element.isParent ? 'Parent' : 'Children'}}
                    </span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="customer">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.customer' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element.customer.name}}<br>
                  <span *ngIf="element.customer.city" style="font-weight: 600;">
                    {{element.customer.city}} - {{element.customer.locality}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="material">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.material' | translate}} <br>
                  {{'LOAD_DASHBOARD.vehicleType' | translate}} <br>
                  {{'LOAD_DASHBOARD.rate' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element.material}} <br>
                  <span style="font-weight: 600;">
                    {{element.vehicle_type}}
                  </span>
                  <br>
                  <span style="font-weight: 500;">
                    {{element.vehcile_type_rate}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="allocated">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.allocated' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element.allocated_weight}}
                  <br>
                  <div *ngIf="!element.accepted && !element.assigned" class="buttonMain"
                    (click)="$event.stopPropagation(); openAcceptanceConfirmDialog(element)">
                    <div class="button">
                      Accept
                    </div>
                  </div>

                  <div *ngIf="element.accepted && !element.assigned" class="buttonMain"
                    (click)="$event.stopPropagation(); openAssignModal(element)"
                    style="background: #48C479; border: 1px solid #48C479;">
                    <div class="button">
                      Assign
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="driver">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.driverDetails' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span style="font-weight: 600;">
                    {{element.vehicleNo}}
                  </span>
                  <br>
                  <span>
                    {{element.driverName}}
                  </span>
                  <br>
                  <span>
                    {{element.driverMobile}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="shipment">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.shipment' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span style="font-weight: 600;">
                    {{element.shipment}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="deadlines">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.acceptanceDeadline' | translate}} <br>
                  {{'LOAD_DASHBOARD.assignmentDeadline' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span style="font-weight: 500;">
                    {{element.acceptanceDeadlineDate}}
                  </span>
                  <span style="font-weight: 600; margin-bottom: 4px; display: inline-block;">
                    {{element.acceptanceDeadlineTime}}
                  </span>
                  <br>
                  <span style="font-weight: 500;">
                    {{element.assignmentDeadlineDate}}
                  </span>
                  <span style="font-weight: 600;">
                    {{element.assignmentDeadlineTime}}
                  </span>
                  <br>
                </td>
              </ng-container>
              <ng-container matColumnDef="shipper">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.shipper' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span style="font-weight: 600;">
                    {{element.shipper?.parent_name}}
                  </span>
                  <span>
                    - {{element.shipper?.name}}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"
                style="font-weight: bold !important; height: 50px;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns; let i=index;"
                [ngClass]="{'highlighted-row': row.assigned && row.accepted}" style="font-family: 'Inter', sans-serif;">
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="mobile-view">
        <div class="card-container">
          <div class="load-card" *ngFor="let element of dataSource.data; let i = index"
            [ngClass]="{'highlighted-row': element.assigned && element.accepted}">
            <div class="card-header">
              <div class="card-index">#{{i+1}}</div>
              <div class="card-load">
                <div class="load-number">{{element.load}} <strong>({{element.SONo}})</strong></div>
              </div>
              <div class="card-indicator" *ngIf="element.isParent || element.isChildren">
                <span [ngClass]="{'parent-indicator': element.isParent, 'children-indicator': element.isChildren}">
                  {{element.isParent ? 'Parent' : 'Children'}}
                </span>
              </div>
            </div>

            <div class="card-body">
              <div class="card-column">
                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.customer' | translate}}</div>
                  <div class="section-content">
                    <div>{{element.customer.name}}</div>
                    <div *ngIf="element.customer.city" class="location">
                      <strong>{{element.customer.city}} - {{element.customer.locality}}</strong>
                    </div>
                  </div>
                </div>

                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.material' | translate}}</div>
                  <div class="section-content">
                    <div class="material-line">{{element.material}} | {{element.vehicle_type}} |
                      {{element.vehcile_type_rate}}</div>
                  </div>
                </div>

                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.driverDetails' | translate}}</div>
                  <div class="section-content">
                    <div class="driver-line"><strong>{{element.vehicleNo}}</strong> | {{element.driverName}} |
                      {{element.driverMobile}}</div>
                  </div>
                </div>
              </div>

              <div class="card-column">
                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.allocated' | translate}}</div>
                  <div class="section-content">
                    <div class="allocated-weight">{{element.allocated_weight}}</div>
                  </div>
                </div>

                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.shipment' | translate}}</div>
                  <div class="section-content">
                    <strong>{{element.shipment}}</strong>
                  </div>
                </div>

                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.acceptanceDeadline' | translate}}</div>
                  <div class="section-content">
                    <div class="deadline-line">{{element.acceptanceDeadlineDate}}
                      <strong>{{element.acceptanceDeadlineTime}}</strong></div>
                  </div>
                </div>

                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.assignmentDeadline' | translate}}</div>
                  <div class="section-content">
                    <div class="deadline-line">{{element.assignmentDeadlineDate}}
                      <strong>{{element.assignmentDeadlineTime}}</strong></div>
                  </div>
                </div>

                <div class="card-section">
                  <div class="section-label">{{'LOAD_DASHBOARD.shipper' | translate}}</div>
                  <div class="section-content">
                    <strong>{{element.shipper?.parent_name}}</strong> - {{element.shipper?.name}}
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div *ngIf="!element.accepted && !element.assigned" class="mobile-button accept-button"
                (click)="$event.stopPropagation(); openAcceptanceConfirmDialog(element)">
                Accept
              </div>
              <div *ngIf="element.accepted && !element.assigned" class="mobile-button assign-button"
                (click)="$event.stopPropagation(); openAssignModal(element)">
                Assign
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="showLoader" class="loader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <ng-template #noOrders>
        <div class="noOrders" style="padding: 30px; text-align: center;">
          {{'ORDER_DASHBOARD.noOrder' | translate}}
        </div>
      </ng-template>
    </div>

    <!-- Sticky Pagination for both views -->
    <div class="footer">
      <mat-paginator fixed [length]="(dataSource)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25"
        [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageNavigate($event)"></mat-paginator>
    </div>
  </div>
</div>

<ng-template #acceptanceConfirm>
  <button mat-icon-button class="acceptance-confirm-close-button" [mat-dialog-close]="true">
    <mat-icon (click)="closeAcceptanceConfirmDialog()" class="close_icon">close</mat-icon>
  </button>

  <div class="acceptance-confirm-container">
    <div class="acceptance-confirm-content">
      {{'LOAD_DASHBOARD.acceptConfirmDialogContent' | translate}}<br />
      {{'LOAD_DASHBOARD.acceptConfirmDialogSubContent' | translate}}
    </div>
    <div class="acceptance-confirm-footer">
      <button class="acceptance-confirm-btn" (click)="acceptLoad()">
        {{'LOAD_DASHBOARD.confirmButton' | translate}}
      </button>
      <button class="acceptance-cancel-btn" (click)="closeAcceptanceConfirmDialog()">
        {{'LOAD_DASHBOARD.cancelButton' | translate}}
      </button>
    </div>
  </div>
</ng-template>